import { formatInTimeZone } from 'date-fns-tz';

export const HOME_TIME_ZONE = 'America/Los_Angeles';
export const UTC_TIME_ZONE = 'UTC';

function toTimeZone(dateStr: string, timeZone: string, format: string) {
  return formatInTimeZone(dateStr, timeZone, format);
}

export function articleDate(dateStr: string) {
  return toTimeZone(dateStr, HOME_TIME_ZONE, 'MMM d, yyyy h:mmaaa zzz');
}

export function articleTime(dateStr: string) {
  return toTimeZone(dateStr, HOME_TIME_ZONE, 'h:mmaaa zzz');
}

export function dateInLocalTimezone(dateStr: string, format = 'MMMM d, yyyy') {
  if (!dateStr) return '';

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return toTimeZone(dateStr, userTimeZone, format);
}

export const formatUtcDate = (dateStr: string) => {
  return toTimeZone(dateStr, UTC_TIME_ZONE, 'MMMM dd, yyyy');
};

export const isPastDate = (utcDateString: string): boolean => {
  const givenDate = new Date(utcDateString);
  const now = new Date();
  return givenDate < now;
};

export const formatEventDateRange = (startDateStr: string, additionalDayTimes: string) => {
  if (!additionalDayTimes) return startDateStr;
  const trimmed = additionalDayTimes.trim();
  if (trimmed === '') return startDateStr;

  const startDate = new Date(startDateStr);

  const additionalDays = trimmed.split('\n').filter(Boolean).length;
  if (additionalDays === 0) return startDateStr;

  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + additionalDays);

  return (
    startDateStr +
    ' \u2013 ' +
    endDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  );
};
